import { render, staticRenderFns } from "./tarifa-ficha.vue?vue&type=template&id=74c84c51&scoped=true"
import script from "./tarifa-ficha.vue?vue&type=script&lang=js"
export * from "./tarifa-ficha.vue?vue&type=script&lang=js"
import style0 from "./tarifa-ficha.vue?vue&type=style&index=0&id=74c84c51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c84c51",
  null
  
)

export default component.exports